import { useQuery } from "@tanstack/react-query";
import Chevron from "../components/Icons/Chevron";
import { Helmet } from "react-helmet";
import { GetCart } from "../api/Cart/GetCart";
import CartPaymentDetails from "../components/Payment/CartPaymentDetails";
import Spinner from "../components/Shared/Spinner";

const CartCheckout = () => {
  const { data: CartData, isLoading: isLoading } = useQuery({
    queryFn: GetCart,
    queryKey: ["cart"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const cart = CartData?.data;

  return (
    <div className="mt-20 md:pt-40 pt-20 container min-h-screen">
      <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/cart-checkout" />
      </Helmet>

      <div className="flex items-center gap-2 mb-11 mt-16">
        <div className="w-2 sm:h-[50px] h-8 rounded-2xl bg-primary sm:mr-1"></div>
        <div className="flex items-center gap-0.5 text-burntBlack/85 font-medium sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
          Checkout <Chevron />
        </div>
        <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
          Payment
        </div>
      </div>
      <div className="flex gap-11 justify-between">
        {isLoading ? (
          <div className="flex w-full h-[30vh] items-center justify-center">
            <Spinner />
          </div>
        ) : (
          cart && <CartPaymentDetails cart={cart} />
        )}
      </div>
    </div>
  );
};

export default CartCheckout;
